export const FETCH_MAIN_NAVIGATION = "FETCH_MAIN_NAVIGATION";
export const FETCH_ROUTES = "FETCH_ROUTES";
export const FETCH_PROJECTS = "FETCH_PROJECTS";
export const FETCH_ABOUT_DATA = "FETCH_PAGE_DATA";
export const TOGGLE_NAVIGATION = "TOGGLE_NAVIGATION";
export const FETCH_DOWNLOADS = "FETCH_DOWNLOADS";
export const FETCH_TAXONOMY = "FETCH_TAXONOMY";
export const SET_CURRENT_FILTER = "SET_CURRENT_FILTER";
export const FETCH_JOBS = "FETCH_JOBS";
export const FETCH_CONTACT_FORM = "FETCH_CONTACT_FORM";
export const SUBMIT_CONTACT_FORM = "SUBMIT_CONTACT_FORM";
export const FETCH_NEWS = "FETCH_NEWS";
export const FETCH_NEWS_TAXONOMY = "FETCH_NEWS_TAXONOMY";
export const SELECT_NEWS = "SELECT_NEWS";
export const FETCH_HOMEPAGE_DATA = "FETCH_HOMEPAGE_DATA";
export const SELECT_PROJECT = "SELECT_PROJECT";
export const SELECT_JOB = "SELECT_JOB";
export const DETECT_ROUTE_ANIMATION = "DETECT_ROUTE_ANIMATION";
export const DETECT_MOUSE_STATE = "DETECT_MOUSE_STATE";
export const FETCH_SINGLE_NEWS = "FETCH_SINGLE_NEWS";
export const FETCH_COOKIE_DATA = "FETCH_COOKIE_DATA";
export const FETCH_CONTACT_DATA = "FETCH_CONTACT_DATA";



// WEBPACK FOOTER //
// ./src/constants/actionTypes.js